import { Button, Group } from '@mantine/core';
import { CreateAnotherButton } from './CreateAnotherButton';

export const EditableDisplayBar = ({
    isDirty,
    form,
    handleSaveButtonClick,
    handleCancelButtonClick,
    handleResetButtonClick,
    withCreateAnother,
    saveButtonLabel
}: {
    isDirty: boolean;
    form?: string;
    handleSaveButtonClick?: () => void;
    handleCancelButtonClick?: () => void;
    handleResetButtonClick?: () => void;
    withCreateAnother?: boolean;
    saveButtonLabel?: string;
}) => {
    return (
        <Group
            gap="xs"
            justify="flex-end"
            pt="xs"
            pr="xs"
        >
            {withCreateAnother && <CreateAnotherButton />}
            {handleCancelButtonClick ?
                <Button
                    color="gray"
                    onClick={handleCancelButtonClick}
                >
                    Cancel
                </Button>
                :   undefined}
            {handleResetButtonClick ?
                <Button
                    color="gray"
                    onClick={handleResetButtonClick}
                    disabled={!isDirty}
                >
                    Reset
                </Button>
                :   undefined}
            {handleSaveButtonClick ?
                <Button
                    type={form ? 'submit' : undefined}
                    form={form}
                    variant="filled"
                    onClick={handleSaveButtonClick}
                    disabled={!isDirty}
                >
                    {saveButtonLabel ?? "Save"}
                </Button>
                :   undefined}
        </Group>
    );
};
